import ComboBoxMultiple, { ComboBoxMultipleProp } from "@/components/molecules/combobox/ComboBoxMultiple";
import ComboBoxSingle, { ComboBoxSingleProp } from "@/components/molecules/combobox/ComboBoxSingle";

export type ComboBoxProps<T extends { id: string; name: string }, Multiple extends boolean> = Multiple extends true
  ? ComboBoxMultipleProp<T>
  : ComboBoxSingleProp<T>;

const ComboBox = <T extends { id: string; name: string }, Multiple extends boolean>({
  multiple,
  ...props
}: { multiple: Multiple } & ComboBoxProps<T, Multiple>) => {
  if (multiple) {
    return <ComboBoxMultiple {...(props as ComboBoxMultipleProp<T>)} />;
  } else {
    return <ComboBoxSingle {...(props as ComboBoxSingleProp<T>)} />;
  }
};

export default ComboBox;
